// src/components/ErrorBoundary.jsx
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('🚨 ErrorBoundary:', error, info);

    const msg = String(error?.message || '');
    const isChunkError =
      error?.name === 'ChunkLoadError' ||
      /Loading chunk .* failed/i.test(msg) ||
      /Failed to fetch dynamically imported module/i.test(msg);

    if (isChunkError) {
      const key = 'chunk_reload_attempted';
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, '1');
        window.location.reload();
      }
    }
  }

  handleTryAgain = () => this.setState({ hasError: false });

  handleReload = () => {
    try { sessionStorage.removeItem('chunk_reload_attempted'); } catch {}
    window.location.reload();
  };

  handleGoHome = () => {
    try { sessionStorage.removeItem('chunk_reload_attempted'); } catch {}
    window.location.href = '/';
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div dir="rtl" style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', padding: 24,
        textAlign: 'center', background: '#f8fafc', color: '#1e293b',
        fontFamily: 'inherit',
      }}>
        <div style={{ fontSize: 72, marginBottom: 16 }}>😕</div>
        <h2 style={{ margin: 0, fontSize: 22 }}>مشکلی پیش آمد</h2>
        <p style={{ color: '#64748b', marginTop: 8, maxWidth: 340, lineHeight: 1.7 }}>
          بخشی از برنامه با خطا مواجه شد. می‌توانید دوباره تلاش کنید.
        </p>
        <div style={{ marginTop: 24, display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
          <button onClick={this.handleTryAgain} style={{
            padding: '10px 22px', borderRadius: 10, border: '1px solid #cbd5e1',
            background: 'white', cursor: 'pointer', fontSize: 14, fontFamily: 'inherit',
          }}>🔄 تلاش مجدد</button>
          <button onClick={this.handleReload} style={{
            padding: '10px 22px', borderRadius: 10, border: 'none',
            background: '#3b82f6', color: 'white', cursor: 'pointer',
            fontSize: 14, fontFamily: 'inherit',
          }}>بازخوانی صفحه</button>
          <button onClick={this.handleGoHome} style={{
            padding: '10px 22px', borderRadius: 10, border: 'none',
            background: '#e2e8f0', cursor: 'pointer', fontSize: 14,
            fontFamily: 'inherit', color: '#1e293b',
          }}>🏠 صفحه اصلی</button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;